/**
 * soubor se seznamem veškerých graphql dotazů pro změnu hesla
 */
import gql from 'graphql-tag';

export const CHANGE_PASSWORD = gql`
    mutation changeAdminPassword($oldPassword:String!,$password:String!) {
        changeAdminPassword(oldPassword:$oldPassword,password:$password)
    }
`;